const m3 = 'm³';

export const Sm3s = `S${m3}/s`;
export const m3hr = `${m3}/hr`;
export const m3Mlnm3 = `${m3}/Mln.${m3}`;
export const TJ = 'TJ';
